exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tagClose[data-v-2ac5956c]{font-size:14px;margin-left:10px;cursor:pointer}.tabText[data-v-2ac5956c],.tagClose[data-v-2ac5956c]{display:inline-block;vertical-align:middle}.tabText[data-v-2ac5956c]{max-width:260px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.tagClose[data-v-2ac5956c]:hover{color:#cc0031}.tabInputBox[data-v-2ac5956c]{border:1px solid #ddd;border-radius:4px;background-color:#fff;width:100%;cursor:text;min-height:34px}.tagInput[data-v-2ac5956c]{display:inline-block;max-width:260px}", ""]);

// exports
